import React from 'react';
import Form from './Form';

export default class Subform extends Form {

	render() {
		const factory = React.createFactory(this.props.class);
		return new factory({
			state: this.props.state,
			index: this.props.index,
			onRemove: this.props.onRemove,
			parentProps: this.props.parentProps
		});
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-forms/src/Subform.js